<template>
  <div>
    <p class="text-white">Entrez votre date de naissance:</p>

    <b-form class="text-center mt-4">
      <b-input-group>
        <b-form-select v-model="birth.day" :options="dayOptions" class="select"></b-form-select>
        <b-form-select v-model="birth.month" :options="monthOptions" class="select"></b-form-select>
        <b-form-select v-model="birth.year" :options="yearOptions" class="select"></b-form-select>
      </b-input-group>

      <b-button @click="triggerCalculation" variant="success" class="mt-2">Continuer</b-button>
    </b-form>
  </div>
</template>

<script>
import { BForm, BInputGroup, BFormSelect, BButton } from "bootstrap-vue";
import getDaysInMonth from "date-fns/getDaysInMonth";

import { MONTHS } from "@/constants/members";
import { calculateLifepath } from "@/helpers/experiences";

export default {
  name: "Birthdate",
  components: { BForm, BInputGroup, BFormSelect, BButton },
  data() {
    return {
      birth: {
        year: new Date().getFullYear(),
        month: 1,
        day: 1,
      },

      dayOptions: [],
      monthOptions: [],
      yearOptions: [],
    };
  },
  mounted() {
    this.initDayOptions();
    this.initMonthOptions();
    this.initYearOptions();
  },
  methods: {
    triggerCalculation() {
      const { birth } = this;

      const result = calculateLifepath(birth);
      this.$emit("success", birth, result);
    },
    initDayOptions() {
      const { year, month, day } = this.birth;

      const tempDate = new Date(year, month - 1, day);
      const endDays = getDaysInMonth(tempDate);

      for (let i = 1; i <= endDays; i++) {
        this.dayOptions.push({ value: i, text: i });
      }
    },
    initMonthOptions() {
      for (let i = 1; i <= 12; i++) {
        this.monthOptions.push({ value: i, text: MONTHS[i - 1] });
      }
    },
    initYearOptions() {
      let cuYear = new Date().getFullYear();
      for (let i = cuYear; i >= cuYear - 100; i--) {
        this.yearOptions.push({ value: i, text: i });
      }
    },
  },
};
</script>
